<app-dialog
  [dialogType]="dialogType"
  [headerLabel]="'DIALOG.FEEDBACK.TITLE' | translate"
  [primaryActionText]="'ACTION.SEND' | translate"
  [secondaryActionText]="'ACTION.CANCEL' | translate"
  [primaryActionDisabled]="!descriptionFormControl.value"
  (onPrimaryAction)="sendFeedback()"
  (onSecondaryAction)="onDismiss()"
  (onCloseAction)="onDismiss()"
>
  <div class="feedback-dialog">
    <app-textarea-field
      class="feedback-field"
      [hideLabel]="true"
      [noMaxHeight]="true"
      fieldId="feedback_field"
      [placeholder]="'DIALOG.FEEDBACK.PLACEHOLDER' | translate"
      [fieldControl]="descriptionFormControl"
      [removeNativeAutocomplete]="true"
    >
    </app-textarea-field>
  </div>
</app-dialog>
